import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=22873e48&"
import script from "./TopNavigation.vue?vue&type=script&lang=js&"
export * from "./TopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports